import TravellerProfileConfirmationMessage from './traveller-profile-confirmation-message-component';

import './traveller-profile-confirmation-message.scss';

const MODULE_NAME = 'traveller-profile-confirmation-message';
const module = angular.module(MODULE_NAME, [])
    .directive(TravellerProfileConfirmationMessage.DIRECTIVE_NAME, TravellerProfileConfirmationMessage);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/traveller-profile-confirmation-message/traveller-profile-confirmation-message-module.js